import { AppThunk } from '../actions';
import { SiteActions } from '../actions/site-actions';
import * as ApiRequests from '../../api/requests';
import { AuthHelper, SiteProfile, SiteRegistration } from '../../types';
import { EMPTY_STRING } from '../../constants';

function getCountryId(country: string): string {
    let countryId = "1";
    if (country === 'US') {
        countryId = '1';
    } else if (country === 'CA') {
        countryId = '2';
    }
    return countryId
}
export const SiteThunks = {
    createSiteRegistration: (
        siteDetails: SiteRegistration,
        addToast: Function,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(SiteActions.SiteRegistrationStarted());

        const payload = await ApiRequests.siteRegistration(siteDetails, { authHelper: authHelper });
        if (payload.ok) {
            dispatch(SiteActions.SiteRegistrationSucceeded(payload.response.data.id, payload.response.data.name));
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(SiteActions.SiteRegistrationFailed());
    },
    updateSiteRegistration: (
        siteId: string,
        siteDetails: SiteProfile,
        addToast: Function,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(SiteActions.SiteRegistrationStarted());

        const payload = await ApiRequests.updateSiteProfile(
            {
                siteId: siteId,
                type: siteDetails.type,
                name: siteDetails.name,
                description: siteDetails.description || EMPTY_STRING,
                contact: siteDetails.contact || EMPTY_STRING,
                email: siteDetails.email || EMPTY_STRING,
                phone: siteDetails.phone || EMPTY_STRING,
                parentSiteId: siteDetails.parentSiteId,
                siteAttributes: {
                    address: siteDetails.address || EMPTY_STRING,
                    city: siteDetails.city,
                    country: siteDetails.country,
                    state: siteDetails.state,
                    zipCode: siteDetails.zipCode,
                    latitude: siteDetails.latitude,
                    longitude: siteDetails.longitude,
                },
            },
            { authHelper: authHelper }
        );

        if (payload.ok) {
            dispatch(SiteActions.SiteRegistrationSucceeded(payload.response.data.id, payload.response.data.name));
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(SiteActions.SiteRegistrationFailed());
    },

    deleteSite: (siteId: string, addToast: Function, authHelper: AuthHelper): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(SiteActions.SiteDeleteStarted());

        const payload = await ApiRequests.deleteSite(
            {
                siteId: siteId,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(SiteActions.SiteDeleteSucceeded());
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(SiteActions.SiteDeleteFailed(`${ApiRequests.extractResponseNotOkCode(payload.response)}`));
    },
    getExludedStateResponse: (
        selectedState: string,
        country: string,
        addToast: Function,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(SiteActions.SiteRegistrationStarted());

        const payload = await ApiRequests.getDaylightSavingExcludedStates(
            {
                countryid: getCountryId(country),
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(SiteActions.ExludeStateSucceeded(payload.response.data, country, selectedState));
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(SiteActions.SiteRegistrationFailed());
    },

};

